<template>
    <div class="proposeList">
        <!-- <div class="header">
            <img src="@/assets/c/icon_back.png"  @click="goHome" alt="">
        </div> -->
        <div class="zhview">
            <div class="zhone">
                <span class="zname">{{ $t("new.zlei") }}</span>
                <div class="jiview">
                    <img src="@/assets/c/img_szjls.png" class="bg" alt="" />
                    <div @click="goToShouRecord" class="jiitem">
                        <!-- <img src="@/assets/c/icon_jl.png" class="icon_jl"  alt=""> -->
                        <span class="jnmae">{{ $t("new.szhi") }}</span>
                    </div>
                </div>
            </div>
            <div class="zhtwo mb">
                <img
                    src="@/assets/c/icon_logos.png"
                    class="icon_logos"
                    alt=""
                />
                <span class="jnmae">GMC</span>
            </div>
            <div class="zhone">
                <span class="zname">{{ $t("new.shouzhi") }}</span>
            </div>
            <div class="zhthree mb">
                <div class="zleft">
                    <input
                        type="text"
                        class="juaninput"
                        v-model="to_address"
                        maxlength="42"
                        :placeholder="$t('new.shushou')"
                    />
                    <!--                     <span class="jnmae" @click="handlePaste">{{ $t('new.zhnatie') }}</span>-->
                </div>
                <img
                    @click="$router.replace({ path: `/Scan` })"
                    src="@/assets/c/icon_sys.png"
                    class="icon_sys"
                    alt=""
                />
            </div>

            <div class="zhone">
                <span class="zname">{{ $t("new.zhuanshu") }}</span>
            </div>
            <div class="zhthree mb">
                <div class="zleft" style="width: 100%">
                    <input
                        type="text"
                        class="juaninput"
                        v-model="number"
                         :placeholder="$t('new.shuzhuan')"
                    />
                    <span class="jquan" @click="all">{{ $t("new.quan") }}</span>
                    <span class="shu"></span>
                    <span class="rval">GMC</span>
                </div>
            </div>
            <div class="zhuanzhang" @click="transfer">
                {{ $t("new.zhuanzhang") }}
            </div>
        </div>
        <div class="guiview">
            <span class="gname">{{ $t("new.gui") }}</span>
            <span
                class="gmiao"
                style="word-wrap: break-word"
                v-html="transferRule"
            ></span>
        </div>
        <div class="fanview" @click="$router.go(-1)">
            <img src="@/assets/c/fan.png" class="bg" alt="" />
        </div>
    </div>
</template>

<script>
import { showToast } from "@/libs/util.js";
import { ajaxData } from "@/api/ajax";
import { mapState, mapActions } from "vuex";
export default {
    data() {
        return {
            number: "",
            rule: "",
            to_address: "",
            address: "",
            gmc_balance: "",
        };
    },
    computed: {
        // 正确用法
        shushou() {
            return this.$t("new.shushou");
        },
        shuzhuan() {
            return this.$t("new.shuzhuan");
        },
    },
    computed: mapState(["transferRule"]),
    created() {
        const address = this.$route.query?.address;
        if (address) {
            this.to_address = address;
        }

        let vm = this;
        vm.getData();
    },
    methods: {
        ...mapActions["setNft"],
        isValidEthereumAddress(address) {
            const regex = /^0x[0-9a-fA-F]{40}$/;
            return regex.test(address);
        },
        async transfer() {
            let vm = this;

            if (!this.isValidEthereumAddress(this.to_address) || this.to_address==''){
                showToast(this.$t("請輸入正確的轉賬地址"));
                return;
            }

            if (this.number == "" || this.number <= 0) {
                showToast(this.$t("請輸入轉賬數量"));
                return;
            }
            
            let res = await ajaxData("/transfer/post", {
                number: vm.number,
                to_address: vm.to_address,
            });
            if (res.code == 0) {
                showToast(vm.$t('transfer_success'));
                vm.number = "";
                vm.to_address = "";
                vm.getData();
            }
            if (res.code == -1) {
                vm.number = "";
                vm.to_address = "";
                showToast(res.msg);
            }
        },
        handlePaste() {
            var clipboardData = window.clipboardData;
            console.log(clipboardData);
            var pastedData = clipboardData.getData("Text");
            console.log(pastedData);
            // 在这里处理粘贴的内容
        },
        all() {
            this.number = this.gmc_balance;
        },
        getData() {
            let vm = this;
            ajaxData("/transfer", {}).then((response) => {
                vm.address = response.data.address;
                vm.gmc_balance = response.data.gmc_balance;
                this.$store.dispatch('setTransferRule',response.data.rule);
                console.log(response);
            });
        },
        goToShouRecord() {
            console.log(111);

            this.$router.push({ path: "/ShouRecord" });
        },
        goHome() {
            this.$router.go(-1);
        },
    },
};
</script>


<style scoped lang="less">
p {
    margin: 0;
    padding: 0;
}

.proposeList {
    width: 100%;
    min-height: 100vh;
    background: #f5f7f9;
    padding-top: 15px;
    .header {
        height: 50px;
        // margin-bottom: 12px;
        // padding: 40px 12px 0 12px;
        padding: 6px;
        box-sizing: border-box;
        background: #f5f7f9;
        display: flex;
        align-items: center;
        justify-content: center;
        position: sticky;
        width: 100%;
        z-index: 10;
        top: 0;
        img {
            width: 18px;
            height: 18px;
            position: absolute;
            left: 10px;
        }

        span {
            font-weight: bold;
            font-size: 18px;
            color: #ffffff;
        }
    }

    .zhview {
        margin: 0 15px;
        background: #ffffff;
        border-radius: 15px;
        padding: 15px;
        .zhone {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: 15px;
            .zname {
                font-weight: bold;
                font-size: 16px;
                color: #111111;
            }
            .jiview {
                margin-left: auto;
                position: relative;
                width: 74px;
                height: 23px;
            }
            .jiitem {
                position: relative;
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                .icon_jl {
                    width: 11px;
                    height: 11px;
                    margin-right: 3px;
                }
                .jnmae {
                    font-weight: 500;
                    font-size: 10px;
                    color: #1a1a1a;
                }
            }
        }
        .zhtwo {
            padding: 10px 15px;
            background: #eeeeee;
            border-radius: 15px;
            display: flex;
            flex-direction: row;
            align-items: center;
            .icon_logos {
                width: 29px;
                height: 29px;
                margin-right: 4px;
            }
            span {
                font-weight: bold;
                font-size: 14px;
                color: #1a1a1a;
            }
        }
        .mb {
            margin-bottom: 20px;
        }
        .zhthree {
            display: flex;
            flex-direction: row;
            align-items: center;
        }
        .zleft {
            width: 80%;
            background: #eeeeee;
            border-radius: 15px;
            padding: 10px 15px;
            display: flex;
            flex-direction: row;
            align-items: center;
            .jnmae {
                margin-left: 10px;
                font-weight: 500;
                font-size: 12px;
                color: #1a1a1a;
            }
        }
        .juaninput {
            font-weight: 500;
            font-size: 14px;
            color: #1a1a1a;
            flex: 1;
            border: none;
            flex: 1;
            background: transparent;
            min-height: 25px;
        }
        .icon_sys {
            margin-left: 15px;
            width: 22px;
            height: 22px;
        }
        .jquan {
            font-weight: bold;
            font-size: 14px;
            color: #01c8e0;
            margin-left: 10px;
        }
        .shu {
            width: 1px;
            height: 10px;
            background: #cccccc;
            display: inline-block;
            margin: 0 10px;
        }
        .rval {
            font-weight: bold;
            font-size: 14px;
            color: #1a1a1a;
        }
    }
    .zhuanzhang {
        height: 44px;
        background: #26e7fe;
        border-radius: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 14px;
        color: #1a1a1a;
        margin-top: 28px;
    }
}
.guiview {
    margin: 25px;
    display: flex;
    flex-direction: column;
    .gname {
        font-weight: bold;
        font-size: 13px;
        color: #575656;
        display: block;
        margin-bottom: 5px;
    }
    .gmiao {
        font-weight: 400;
        font-size: 13px;
        color: #575656;
    }
}
</style>
